import { useState } from "react";

// hangi panel açılınca hangileri kapanır (mevcut davranış birebir korunur)
const CLOSES = { depr: ["count", "report", "bulk"], count: ["report", "bulk", "depr"], report: ["bulk", "count"], bulk: ["report"] };

export function usePanels() {
  const [panels, setPanels] = useState({ bulk: false, report: false, count: false, depr: false });
  const togglePanel = (k) => setPanels((p) => ({ ...p, [k]: !p[k], ...Object.fromEntries(CLOSES[k].map((c) => [c, false])) }));
  const closePanel = (k) => setPanels((p) => ({ ...p, [k]: false }));
  return { panels, togglePanel, closePanel };
}
